import React, { useState } from 'react';
import { AlertTriangle } from 'lucide-react';
import { motion } from 'framer-motion';

const EASE = [0.22, 1, 0.36, 1];

const Row = ({ label, value }) => (
  <li>
    <strong>{label}:</strong>{' '}
    <span>{value === null || value === undefined || value === '' ? '-' : String(value)}</span>
  </li>
);

const ErrorPhase = ({ searchError, scanFailure, resetAll }) => {
  const [copied, setCopied] = useState(false);

  const copyDetails = async () => {
    try {
      await navigator.clipboard.writeText(JSON.stringify(scanFailure, null, 2));
      setCopied(true);
      setTimeout(() => setCopied(false), 1800);
    } catch (error) {
      setCopied(false);
    }
  };

  return (
    <motion.div
      className="vlg-phase"
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -6 }}
      transition={{ duration: 0.32, ease: EASE }}
    >
      <div className="vlg-error">
        <span className="vlg-error__icon">
          <AlertTriangle size={28} aria-hidden="true" />
        </span>
        <h2 className="vlg-error__title">Scan didn&apos;t finish</h2>
        <p className="vlg-error__body">
          {searchError
            || 'Something went wrong gathering your competitor data. Please try again or search a broader business query.'}
        </p>

        {scanFailure && (
          <details className="vlg-error__debug">
            <summary>Technical details (for support)</summary>
            <ul>
              <Row label="Cause" value={scanFailure.kind} />
              <Row label="HTTP status" value={scanFailure.httpStatus} />
              <Row
                label="Server reason"
                value={scanFailure.stage ? `${scanFailure.reason || '-'} (stage: ${scanFailure.stage})` : scanFailure.reason}
              />
              <Row label="Message" value={scanFailure.message} />
              <Row label="Elapsed" value={scanFailure.elapsedMs ? `${(scanFailure.elapsedMs / 1000).toFixed(1)}s` : null} />
              <Row label="Picked from suggestions" value={scanFailure.hasPlaceId} />
              <Row label="Bot-check enabled" value={scanFailure.turnstileEnabled} />
              <Row label="Bot-check passed" value={scanFailure.turnstileObtained} />
              <Row label="Online" value={scanFailure.device?.online} />
              <Row label="Viewport" value={scanFailure.device?.viewport} />
              <Row label="Device" value={scanFailure.device?.ua} />
            </ul>
            <button type="button" className="vlg-btn vlg-btn--ghost" onClick={copyDetails}>
              {copied ? 'Copied' : 'Copy details'}
            </button>
          </details>
        )}

        <button className="vlg-btn" type="button" onClick={resetAll}>
          Try again
        </button>
      </div>

      <style>{`
        .vlg-error__debug { margin: 4px auto 0; max-width: 520px; width: 100%; text-align: left; border: 1px solid #e2e8f0; border-radius: 12px; background: #f8fafc; padding: 12px 14px; }
        .vlg-error__debug > summary { cursor: pointer; font-weight: 700; color: #334155; font-size: 0.85rem; }
        .vlg-error__debug ul { list-style: none; margin: 10px 0 0; padding: 0; display: grid; gap: 6px; }
        .vlg-error__debug li { font-size: 0.8rem; color: #475569; line-height: 1.4; word-break: break-word; }
        .vlg-error__debug strong { color: #0a0a0a; }
        .vlg-error__debug .vlg-btn { margin-top: 12px; }
      `}</style>
    </motion.div>
  );
};

export default ErrorPhase;
